import { z } from "zod";
import { ReportDownloadTypeEnumSchema } from "@/Enums/ReportDownloadTypeEnum";

export const DownloadReportInputSchema = z.object({
    reportHistoryId: z.string(),
    type: ReportDownloadTypeEnumSchema,
    group: z.string().nullable(),
});

export type DownloadReportInput = z.infer<typeof DownloadReportInputSchema>;